import LocationAutocomplete from "./LocationAutocomplete"

export default  LocationAutocomplete;



// WEBPACK FOOTER //
// ./src/common/components/Map/LocationAutocomplete/index.js